"use client"

import { useTranslations } from "next-intl"

/**
 * "Seguir mi pedido" en la confirmación. Hermano de AccountClaimCard: no decide
 * NADA — el servidor que creó la orden acuñó el link (o null) y aquí solo se
 * pinta. Sin `navigator`, sin `useEffect`, probable con renderToStaticMarkup.
 * Abre en pestaña nueva: la confirmación (y el bloque del recibo por SMS) se
 * quedan donde están.
 *
 * Tokens de Redy (rojo + carbón): el seguimiento es de Redy y cruza locales,
 * igual que el pase y la cuenta. Misma anatomía que la tarjeta de la cuenta
 * para que el ojo la reconozca: etiqueta, promesa, CTA en carbón, el cómo.
 */
export function TrackingCta({ url }: { url: string | null }) {
  const t = useTranslations("public.onlineOrder.checkout")
  if (!url) return null

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full overflow-hidden rounded-2xl border transition hover:opacity-95 active:scale-[0.99]"
      style={{ borderColor: "var(--redy-border)", backgroundColor: "var(--redy-surface)" }}
    >
      <div className="px-5 pt-5 pb-4">
        <p className="text-[10.5px] font-bold uppercase tracking-[0.2em]" style={{ color: "var(--redy-red)" }}>
          {t("trackingCtaLabel")}
        </p>
        <p className="mt-1.5 text-[17px] font-extrabold leading-tight" style={{ color: "var(--redy-charcoal)" }}>
          {t("trackingCtaTitle")}
        </p>
      </div>
      <div className="px-4 pb-4">
        <span
          className="block rounded-xl px-4 py-3.5 text-center text-[15px] font-bold leading-tight text-white"
          style={{ backgroundColor: "var(--redy-charcoal)" }}
        >
          {t("trackingCta")}
        </span>
        <span className="mt-2.5 block px-1 text-center text-[12px] leading-snug" style={{ color: "var(--redy-muted)" }}>
          {t("trackingCtaHint")}
        </span>
      </div>
    </a>
  )
}
